import { gql } from '@apollo/client';
import { ClientCartonDetailResult } from '../types/ClientCartonTypes';

export const GET_CLIENT_CARTON_DETAIL = gql`
    query GetClientCartonDetail($id: Long!) {
        getClientCartonDetail(id: $id) {
            bigBagNo
            masterWaybillNo
            channelName
            createdAt
            arrivePortCode
            scanStatus
            scanType
            scanPort
            parcelCount
            onlineParcelCount
            individualScanCount
            parcels {
                trackingNumber
                orderStatus
                orderId
            }
        }
    }
`;

export interface GetClientCartonDetailResponse {
    getClientCartonDetail: ClientCartonDetailResult | null;
}
